import axios from 'axios';
import jwt from 'jsonwebtoken';
import _ from 'lodash';
import { FUSE_OPTIONS } from './fuseOptions';

const ajax = axios.create({
  baseURL: process.env.REACT_APP_CORE_USER_API_URL,
  headers: { 'Content-Type': 'application/json' },
  withCredentials: true
});

export { FUSE_OPTIONS };

export const idFormatter = (string) => string.toLowerCase().split(' ').join('-');

export function createFilterList(data, keyName) {
  return _.uniqBy(data.map((item) => ({ name: item[keyName], id: item.id, isChecked: false })), 'name');
}

export function getCookie(name) {
  let matches = document.cookie.match(new RegExp(
    // eslint-disable-next-line no-useless-escape
    '(?:^|; )' + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + '=([^;]*)'
  ));
  return matches ? decodeURIComponent(matches[1]) : undefined;
}

export function deleteCookie() {
  var res = document.cookie;
  var multiple = res.split(';');
  for (var i = 0; i < multiple.length; i++) {
    var key = multiple[i].split('=');
    document.cookie = key[0] + ' =; expires = Thu, 01 Jan 1970 00:00:00 UTC;domain=.parkhub.com';
  }
}

export function getAuthUser() {
  return jwt.decode(getCookie('86553b39'), { complete: true }).payload.payload;
}

export function TreeConstructor(unstructured) {
  let finalForm = {};
  let leaf = '';
  if (unstructured.name && unstructured.children && unstructured.children.length > 0) {
    finalForm[unstructured.name] = unstructured.children.map(child => {
      return TreeConstructor(child);
    });
  } else if (unstructured.name) {
    leaf = unstructured.name;
  }
  return finalForm[unstructured.name] ? finalForm : leaf;
};

export function refreshSession() {
  const value = getCookie('86553b39');

  if (value && value !== 'undefined') {
    return ajax.post('authenticate?refreshCookie=true');

  } else {
    console.error(`Can not refresh session because current cookie expired`);
  }
}

export function signOut(params = '') {
  return window.location.replace(`${process.env.REACT_APP_SUITE_URL + 'sign-out' + params}`);
}

export function getSessionTime() {
  const iat = jwt.decode(getCookie('86553b39'), { complete: true }).payload.iat;
  return Math.abs((new Date(iat * 1000) - new Date()) / 1000 / 60);
}



// WEBPACK FOOTER //
// ./src/utils/index.js